/* eslint-disable quotes */
import {
  Color,
  ColorSchema,
  ColorStatus,
} from "themes/interfaces";

export default {
  status: {
    warning: { color: "#FEDB60", text: "#404040" } as ColorSchema,
    success: { color: "#57A75B", text: "#ffffff" } as ColorSchema,
    error: { color: "#CF4F4F", text: "#ffffff" } as ColorSchema,
    info: { color: "#4F8FCF", text: "#ffffff" } as ColorSchema,
  } as ColorStatus,
  palette: {
    blue: { color: "#005cff", text: "#ffffff", accent: "#4f75ff", textAccent: "#404040" } as ColorSchema,
    green: {
      color: "#6ea757", text: "#404040", accent: "#57A75B", textAccent: "#404040"
    } as ColorSchema,
    orange: {
      color: "#ff784f", text: "#404040", accent: "#ff674f", textAccent: "#404040"
    } as ColorSchema,
    pink: { color: "#ff4f78", text: "#404040", accent: "#fd3e7c", textAccent: "#404040" } as ColorSchema,
    purple: { color: "#724fff", text: "#ffffff", accent: "#5a4fff", textAccent: "#ffffff" } as ColorSchema,
    red: { color: "#ff4f4f", text: "#404040", accent: "#e15858", textAccent: "#404040" } as ColorSchema,
    teal: { color: "#00c16a", text: "#404040", accent: "#61b3a8", textAccent: "#404040" } as ColorSchema,
    yellow: { color: "#fedb60", text: "#404040", accent: "#ffd337", textAccent: "#404040" } as ColorSchema,
  } as any,
  black: "#000000",
  white: "#FFFFFF"
} as Color;
